import { Skeleton } from '@synoptic/ui-kit/skeleton/skeleton.js';
import { borderRadius } from '@synoptic/ui-kit/tokens.js';
import { useHighlightedAuthors } from '../../use-highlighted-authors';
import { HomeSectionHeader } from '../home-carousel';
import { HomeAuthorCard } from './home-author-card';
import { homeExploreSection } from '../home-sections.css';
import { authorSectionHeader } from './home-authors-section.css';

export const HomeAuthorsSection = () => {
  const { authors, loading, areAuthorsEmpty } = useHighlightedAuthors();

  if (loading) {
    return <Skeleton radius={borderRadius.r12} height={500} width="100%" />;
  }

  if (areAuthorsEmpty) {
    return null;
  }

  return (
    <div className={homeExploreSection}>
      <>
        <HomeSectionHeader
          className={authorSectionHeader}
          title="Highlighted authors"
        />
        {authors?.map((author) => (
          <HomeAuthorCard key={author.id} author={author} />
        ))}
      </>
    </div>
  );
};
